import { CityCenter } from '../constants/MapData';

export const getLatLng = async address => {

  return CityCenter;
};
